const tools = require('../../tools')
const DEFAULT_LIMIT = Number.MAX_SAFE_INTEGER

exports.get = (state, { locationId, date, filter, includeProgramsHistory }) => {
  return state.locationsDB.get(locationId)
    .then(doc => tools.docToEntity({ doc, date, filter, includeProgramsHistory }))
}

exports.getRawDoc = async (state, { locationId, warehouseCode }) => {
  if (locationId) {
    try {
      return await state.locationsDB.get(locationId)
    } catch (err) {
      if (err.name === 'not_found') {
        return
      }
      throw err
    }
  }

  if (warehouseCode) {
    let result
    try {
      result = await state.locationsDB.query(
        tools.constants.BY_WAREHOUSE_CODE_VIEW_NAME, {
          key: warehouseCode,
          include_docs: true
        }
      )
    } catch (err) {
      if (err.status === 404) {
        throw new Error(`No design doc found for view "${tools.constants.BY_WAREHOUSE_CODE_VIEW_NAME}"`)
      }
      throw err
    }
    if (!result || !result.rows || !result.rows.length) {
      return
    }
    return result.rows[0].doc
  }

  throw new Error('Expected either `locationId` or `warehouseCode` to be passed')
}

exports.getRawDocByWarehouseCodes = async (state, warehouseCodes) => {
  let result
  try {
    result = await state.locationsDB.query(
      tools.constants.BY_WAREHOUSE_CODE_VIEW_NAME, {
        keys: warehouseCodes,
        include_docs: true
      }
    )
  } catch (err) {
    if (err.status === 404) {
      throw new Error(`No design doc found for view "${tools.constants.BY_WAREHOUSE_CODE_VIEW_NAME}"`)
    }
    throw err
  }

  if (!result || !result.rows || !result.rows.length) {
    return []
  }

  const docs = result.rows.map(r => r.doc)
    .filter(r => r)

  return docs
}

exports.getRawDocByIds = async (state, ids) => {
  const db = state.locationsDB
  return db.allDocs({
    keys: ids,
    include_docs: true
  })
    .then(results => results.rows
      .map(r => r.doc)
      .filter(r => r)
    )
}

exports.listIdsByLevels = async (state, levels = []) => {
  if (!Array.isArray(levels) || levels.length === 0) {
    return []
  }

  const { docs } = await state.locationsDB.find({
    selector: {
      type: { $eq: 'location' },
      level: { $in: levels }
    },
    fields: ['_id'],
    limit: DEFAULT_LIMIT
  })
  return docs
    .map(doc => doc._id)
    .filter(Boolean)
}

exports.listAll = async (state, filters = {}) => {
  // we want to stop fetching all location docs
  // we now have multiple tenants in the same DB
  // so we need to filter by organisation
  // sl does not have organisation, so we use the default prefix
  const locationsDB = state.locationsDB
  const organisationId = state.user.organisationId

  // If we have organisation scoping, use the org view
  if (organisationId) {
    const viewName = tools.constants.BY_ORGANISATION_PREFIX_VIEW_NAME

    const viewQuery = {
      include_docs: true,
      startkey: [organisationId],
      endkey: [organisationId, '\uffff']
    }

    if (filters.prefix) {
      viewQuery.startkey = [organisationId, `${filters.prefix}:`]
      viewQuery.endkey = [organisationId, `${filters.prefix}:\uffff`]
    }

    const result = await locationsDB.query(viewName, viewQuery)
    return result.rows.map(row => row.doc)
  }

  // No organisation — fall back to fast _all_docs
  const getDocs = results => {
    return results.map(result => result.doc)
      .filter(doc => doc.type === 'location')
  }

  const results = await Promise.all([
    locationsDB.allDocs({
      include_docs: true,
      startkey: 'zone:',
      endkey: 'zone:\uffff'
    }),
    locationsDB.allDocs({
      include_docs: true,
      startkey: 'country:',
      endkey: 'country:\uffff'
    })
  ])

  return getDocs(results.flatMap(result => result.rows))
}
